import * as types from './actionTypes';


export function receiveItemType(outlookType, readOnly) {
  return {
    type: types.ITEMTYPE_RECEIVE, 
    outlookType,
    readOnly
  };
}

export function receiveLocation(location) {
    return {
      type: types.ITEMLOCATION_RECIEVE, 
      location
    };
  }

  export function receiveSender(from) {
    return {
        type: types.ITEM_SENDER_RECIEVE, 
        recipients: [{  
          displayName: from.displayName,
          emailAddress: from.emailAddress,
          sender: true
        }]
    };
}


export function receiveToRecipients(recipients) {
    return {
      type: types.ITEM_TO_RECIPIENTS_RECIEVE, 
      recipients: recipients.map(r => { 
          return {  
          displayName: r.displayName,
          emailAddress: r.emailAddress
          }
        })
    };
}

export function receiveCCRecipients(recipients) {
    return {
      type: types.ITEM_CC_RECIPIENTS_RECIEVE, 
      recipients: recipients.map(r => { 
        return {  
        displayName: r.displayName,
        emailAddress: r.emailAddress
        }
      })
    };
}

export function receiveBccRecipients(recipients) {
    return {
        type: types.ITEM_BCC_RECIPIENTS_RECIEVE, 
        recipients: recipients.map(r => { 
            return {  
            displayName: r.displayName,
            emailAddress: r.emailAddress
            }
          })
    };
}



export function checkType() {
    return (dispatch) => {
        let Office = window.Office;
        let item = Office.context.mailbox.item;
        let readOnly = true;

        if(item.itemType === Office.MailboxEnums.ItemType.Appointment) {
            //on appointment check if location.getAsync is present to determine readonly
            if (typeof item.location.getAsync !== 'undefined') { 
                readOnly = false;
            }
        }
        else {
            //on message check if item.to.getAsync is present to determine readonly
            if (typeof item.to.getAsync !== 'undefined') { 
                readOnly = false;
            }
        }

        dispatch(receiveItemType(item.itemType, readOnly));

        if(item.itemType === Office.MailboxEnums.ItemType.Appointment) {
            dispatch(fetchLocation());
        } else {
            dispatch(fetchRecipients());
        }
    }
}

export function fetchLocation() {
    return (dispatch) =>  {
        
        let Office = window.Office;
        let item = Office.context.mailbox.item;

        // check for compose or read by checking if location.getasync exists
        if (typeof item.location.getAsync !== 'undefined') { 
            // if compose mode 
            item.location.getAsync(  (asyncResult) => {
                if (asyncResult.status === Office.AsyncResultStatus.Failed) {
                    console.log("Error getting location from meeting:" + asyncResult.error.message);
                }
                else {
                    // Successfully got the location, store it in state.
                    dispatch(receiveLocation(asyncResult.value));
                }
            });
        }
        else { // if read mode 
            let location = item.location;
            dispatch(receiveLocation(location));
        }
   }
}

export function fetchRecipients() {
    return (dispatch) =>  {
        let Office = window.Office;
        let item = Office.context.mailbox.item;

        // Local objects to point to recipients of either
        // the appointment or message that is being composed.
        // bccRecipients applies to only messages, not appointments.
        let toRecipients, ccRecipients, bccRecipients, from; 
        // Verify if the composed item is an appointment or message.
        if (item.itemType === Office.MailboxEnums.ItemType.Appointment) {
            toRecipients = item.requiredAttendees;
            ccRecipients = item.optionalAttendees;
        }
        else {
            toRecipients = item.to;
            ccRecipients = item.cc;
            bccRecipients = item.bcc;
            from = item.from;
        }

        

        // check for compose or read by checking if to.getasync exists
        if ((item.itemType === Office.MailboxEnums.ItemType.Appointment && typeof item.location.getAsync !== 'undefined') 
            || (item.itemType === Office.MailboxEnums.ItemType.Message  && typeof item.to.getAsync !== 'undefined')) { 
            // if compose mode 
            toRecipients.getAsync( (asyncResult) => {
                if (asyncResult.status === Office.AsyncResultStatus.Failed){
                    console.log("Error getting recipients from message:" + asyncResult.error.message);
                }
                else {
                    dispatch(receiveToRecipients(asyncResult.value));
                }    
            }); // End getAsync for to-recipients.
    
             // Get any cc-recipients.
            ccRecipients.getAsync( (asyncResult) => {
                if (asyncResult.status === Office.AsyncResultStatus.Failed){
                    console.log("Error getting recipients from message:" + asyncResult.error.message);
                }
                else {
                    dispatch(receiveCCRecipients(asyncResult.value));
                }
            }); // End getAsync for cc-recipients.
    
            // If the item has the bcc field, i.e., item is message,
            // get any bcc-recipients.
            if (bccRecipients) {
                bccRecipients.getAsync( (asyncResult) => {
                    if (asyncResult.status === Office.AsyncResultStatus.Failed){
                        console.log("Error getting recipients from message:" + asyncResult.error.message);
                    }
                    else {
                        dispatch(receiveBccRecipients(asyncResult.value));
                    }
        
                }); // End getAsync for bcc-recipients.
            }

            dispatch(receiveSender({ 
                    displayName: Office.context.mailbox.userProfile.displayName, 
                    emailAddress: Office.context.mailbox.userProfile.emailAddress 
                }
            ));

        }
        else { // if read mode 
            dispatch(receiveSender(item.from));
            dispatch(receiveToRecipients(toRecipients));
            dispatch(receiveCCRecipients(ccRecipients));
            if (bccRecipients) {
                dispatch(receiveBccRecipients(bccRecipients));
            }
        }
   }
}







